// removed by extract-text-webpack-plugin
module.exports = {"partnersWrapper":"_2apw_xTC3LflGob4Tt3h7O","partnerLogo":"_11GdtyN__ZixBwQ1kt8LOG","logoWrapper":"_3yh9MxY5JslbsZJ463xHIw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorPartners/RealtorPartners.scss
// module id = 775
// module chunks = 0